/* eslint-disable @typescript-eslint/no-unused-vars */
import { http } from '@/lib/ats-https';
import { http as oldHttp } from '@/lib/http';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  fullResponse?: boolean;
}

// main api calls to get the overall data
const getInterviewSchedulerData = async ({
  stageId,
  activityId,
  contactId,
}) => {
  let url = `ats_interviews/new?ats_job_stage_id=${stageId}&ats_job_stage_action_id=${activityId}`;

  if (contactId) {
    url += `&contact_id=${encodeURIComponent(contactId)}`;
  }

  const { data } = await http.get(url);
  return data;
};

const getTimeZones = async () => {
  const { data } = await oldHttp.get('me/edit');
  return data;
};

const getInterviewLocations = async () => {
  const { data } = await http.get('ats_interviews/locations');
  return data;
};

const getZoomAvailability = async () => {
  return await http.get('ats_interviews/zoom_availability');
};

const getZoomActiveUsers = async ({ query }) => {
  return await http.get(
    `ats_interviews/zoom_active_users${query ? `?q=${query}` : ''}`
  );
};

const getOffices = async () => {
  const { data } = await http.get('ats_offices');
  return data;
};

const getCalenderEventIds = async (payload) => {
  const { data } = await http.post(`calendar_events/trigger_fetch`, payload);
  return data;
};

const getPollCalenderEvents = async ({ eventId, jobId }) => {
  const response = await http.get(
    `calendar_events?fetch_uuid=${eventId}&ats_job_id=${jobId}`
  );
  return response;
};

const getInterviewersList = async ({ startDate, q }) => {
  const response = await http.get(
    `ats_interviews/interviewers?week_start_date=${startDate}&q=${q}`
  );
  return response;
};

const getInterviewerAvailability = async ({
  startDate,
  timeZone,
  interviewerIds = [],
}) => {
  const queryParams = new URLSearchParams({
    week_start_date: startDate,
    time_zone: timeZone,
  });

  interviewerIds?.forEach((id) => queryParams.append('interviewer_ids[]', id));

  const { data } = await http.get(
    `ats_interviews/interviewers_schedule?${queryParams.toString()}`
  );

  return data;
};

const getSuggestedInterviewerId = async (payload) => {
  return await http.post(
    `ats_interviews/trigger_suggested_interviewer`,
    payload
  );
};

const getPollSuggestedInterviewers = async ({ uuId }) => {
  const { data } = await http.get(
    `ats_interviews/suggested_interviewer?fetch_uuid=${uuId}`
  );
  return data;
};

const getMeetingRoomsUuid = async (payload) => {
  const response = await http.post(`meeting_rooms/trigger_fetch`, payload);
  return response;
};

const getPollMeetingRooms = async ({ uuId }) => {
  const response = await http.get(`meeting_rooms?fetch_uuid=${uuId}`);
  return response;
};

//settings page api

const getMeetingRoomSettings = async () => {
  const { data } = await http.get(`meeting_rooms/settings`);
  return data;
};

// Bulk update user timezones
const updateTimezones = async (users: Record<string, string>) => {
  const payload = { users };
  const  data  = await oldHttp.patch('users/update_timezones', payload);
  return data;
};

export const InterviewDetailsAPI = {
  getInterviewSchedulerData,
  getTimeZones,
  getInterviewLocations,
  getZoomAvailability,
  getOffices,
  getCalenderEventIds,
  getPollCalenderEvents,
  getInterviewersList,
  getInterviewerAvailability,
  getSuggestedInterviewerId,
  getPollSuggestedInterviewers,
  getMeetingRoomsUuid,
  getPollMeetingRooms,
  getZoomActiveUsers,
  getMeetingRoomSettings,
  updateTimezones,
};
